import { bus } from '../core/event-bus.js';
import { store } from '../core/state-store.js';
import { runValidation } from '../validation/engine.js';
import { el } from '../utils/dom.js';

export function initValidationPanel() {
  const rulesContainer = document.getElementById('validation-rules');
  const statusEl = document.getElementById('validation-status');
  const runBtn = document.getElementById('validation-run-btn');

  runBtn.addEventListener('click', () => {
    store.update({ validationStatus: 'running' });
    _runAndDisplay(rulesContainer, statusEl);
  });

  // Auto-validate on ad complete/error if toggle is checked
  bus.on('ad:event', ({ type }) => {
    if (type === 'adcomplete' || type === 'aderror' || type === 'addestroyed') {
      const autoValidate = document.getElementById('auto-validate-toggle');
      if (autoValidate?.checked) {
        store.update({ validationStatus: 'running' });
        // Small delay to let final events settle
        setTimeout(() => _runAndDisplay(rulesContainer, statusEl), 500);
      }
    }
  });

  bus.on('validation:run', () => {
    store.update({ validationStatus: 'running' });
    _runAndDisplay(rulesContainer, statusEl);
  });

  bus.on('session:started', () => {
    rulesContainer.innerHTML = '';
    statusEl.textContent = 'Waiting for ad...';
    store.update({ validationStatus: 'pending', validationResults: null });
  });

  bus.on('session:reset', () => {
    rulesContainer.innerHTML = '';
    statusEl.textContent = 'No results yet';
    statusEl.style.color = '';
  });
}

function _runAndDisplay(container, statusEl) {
  const sessionData = store.getSessionData();
  const results = runValidation(sessionData);

  store.update({
    validationStatus: results.failed > 0 ? 'failed' : 'passed',
    validationResults: results,
  });

  bus.emit('validation:completed', results);

  container.innerHTML = '';

  for (const rule of results.rules) {
    const indicator = el('span', {
      className: `validation-indicator ${rule.status === 'pass' ? 'pass' : rule.status === 'fail' ? 'fail' : 'na'}`,
      textContent: rule.status === 'pass' ? '✓' : rule.status === 'fail' ? '✗' : '—',
    });

    const row = el('div', {
      className: 'validation-rule',
      'data-testid': `validation-rule-${rule.id}`,
      title: rule.description,
    }, [
      indicator,
      el('span', { className: 'validation-name', textContent: rule.name }),
      el('span', { className: 'validation-message', textContent: rule.message }),
    ]);

    container.appendChild(row);
  }

  const statusIcon = results.failed > 0 ? '✗' : '✓';
  const statusColor = results.failed > 0 ? 'var(--red)' : 'var(--green)';
  statusEl.textContent = `${statusIcon} ${results.passed} passed, ${results.failed} failed, ${results.skipped} skipped`;
  statusEl.style.color = statusColor;
}
